import { BaseService } from "./BaseService";

import { Preference } from "../models/Preference";

class PreferenceServiceClass extends BaseService {
    protected get baseUrl(): string {
        return `${process.env.NEXT_PUBLIC_API_URL}/api/user/`;
    }

    async getUserSettings(userId: number): Promise<Preference> {
        return this.get(`getUserSettings/${userId}`);
    }

    async updateUserSettings(
        userId: number,
        settings: Preference
    ): Promise<Preference> {
        return this.post(`updateUserSetting/${userId}`, settings);
    }

    async updateUserSettingsWithStatus(
        userId: number,
        settings: Preference
    ): Promise<{ status: number; text: string }> {
        const token = await this.getValidToken();
        const url = `${this.baseUrl.replace(/\/$/, "")}/updateUserSetting/${userId}`;
        const opts: RequestInit = {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(settings),
        };
        const res = await fetch(url, opts);
        const text = await res.text();
        return { status: res.status, text };
    }
}

export const preferenceService = new PreferenceServiceClass();
